import React from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { CardHeader, NuvoCard } from '@nuvolo/nuux-core/components/NuvoCard';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { Asset } from '#/graphql/types';
import If from '#/common/components/If';
import imageNA from '#/static/image-na.webp';
import { color } from '@nuvolo/nuux-theme/utils';
import { useModelProfileImage } from '../../model/hooks/useModelProfileImage';

export interface AssetPanelProps {
  asset: Asset | undefined;
}

const AssetPanel: React.FC<AssetPanelProps> = ({ asset }) => {
  const imageSrc = useModelProfileImage(asset?.model?.id);

  return (
    <NuvoBox backgroundColor={color('contrast', 'light')} id="selected-asset-card">
      <NuvoCard>
        <CardHeader title={''} image={imageSrc || imageNA}>
          <NuvoGrid container>
            {/* Asset Invalid  */}
            <If condition={!asset}>
              <NuvoGrid item xs={12}>
                <NuvoText type="header4">Asset is not valid!</NuvoText>
              </NuvoGrid>
            </If>

            {/* Asset Valid */}
            <NuvoGrid item xs={6} sm={3} id="selector-row">
              <NuvoText type="body" bold>
                {asset?.serialNumber ?? '-'}
              </NuvoText>
              <NuvoLabel>Serial Number</NuvoLabel>
            </NuvoGrid>
            <NuvoGrid item xs={6} sm={3} id="selector-row">
              <NuvoText type="body" bold>
                {asset?.assetType?.name ?? '-'}
              </NuvoText>
              <NuvoLabel>Asset Type</NuvoLabel>
            </NuvoGrid>
            <NuvoGrid item xs={6} sm={3} id="selector-row">
              <NuvoText type="body" bold>
                {asset?.manufacturer?.name ?? '-'}
              </NuvoText>
              <NuvoLabel>Manufacturer</NuvoLabel>
            </NuvoGrid>
            <NuvoGrid item xs={6} sm={3} id="selector-row">
              <NuvoText type="body" bold>
                {asset?.model?.name ?? '-'}
              </NuvoText>
              <NuvoLabel>Model</NuvoLabel>
            </NuvoGrid>
          </NuvoGrid>
        </CardHeader>
      </NuvoCard>
    </NuvoBox>
  );
};

export default React.memo(AssetPanel);
